import ResetPassword from '@/components/ResetPassword';
import api from '@/lib/api'; // ה-Axios instance שיצרנו קודם
import axios from 'axios';

export const authService = {
  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    return data; // מחזיר את ה-access_token, refresh_token והמשתמש
  },

  refreshToken: async (refreshToken: string) => {
    try {
      const { data } = await api.post('/auth/refresh', { refreshToken });
      return data; // מחזיר {session: {access_token, refresh_token}}
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw error.response?.data || error;
      }
      throw error;
    }
  },

  register: async (userData) => {
    try {
      const { data } = await api.post('/auth/signup', userData);
      return data;
    } catch (error) {
      
      if (axios.isAxiosError(error)) {
        console.log(error.response?.data); // כאן יהיה אובייקט השגיאה המלא
        console.log(error.response?.status); // 422
        throw error.response?.data; // זרוק את אובייקט השגיאה כדי שהקריאה ל-register תוכל לטפל בו
      } else {
        console.log(error); // שגיאה שאינה Axios
      }
    }
  },

  googleLogin: async (idToken: string) => {
    try {
      const  data  = await api.post('/auth/google', { id_token : idToken });      
      return data; 
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw error.response?.data || error;
      }
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('fieldOsAccessToken');
  },

  forgetPassword: async (email) => {
    try {
      const { data } = await api.post('/auth/forget-password', { email });
      return data;
    } catch (error) {
      
    }
  },
  ResetPassword: async (password, accessToken, refreshToken) => {
    try {
      const { data } = await api.post('/auth/reset-password', { password, accessToken, refreshToken });
      return data;
    } catch (error) {
      
      return { success: false, message: 'Error resetting password' };
    }
  }
}